<template>
  <div class="pm-dialog-progress">
    <div class="flex justify-center outer-area">
      <div class="vs-col candidate-list" v-for="(master,index) in masterList" :key="index">
        <vs-button
          class="progress-item"
          :color="(String(selectedId) === String(master.id)) ? colorList.find(color => String(color.id) === String(master.id)).value : '#828282' "
          @mousedown="selectedId = String(master.id)"
        >
          {{ master.value }}
        </vs-button>
      </div>
    </div>
    <div class="flex justify-center">
      <div class="current-time-item" >現在時刻  {{ nowStr }}</div>
    </div>


    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
      >
        保存
      </vs-button>
      <vs-button
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("portMasterDestinationWork");

import moment from "moment-timezone";

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
  },
  data() {
    return {
      selectedId: null,
      now: null,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['progress'];
    },
    enableSave() {
      return true; // ( this.selectedId && this.selectedId >= 0 );
    },
    colorList() {
      return this.masterMap['progress_colors'];
    },
    nowStr() {
      return moment(this.now).local().format("HH:mm");
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : null ;
      this.now = moment().valueOf();
    },
    onSubmit(isUpdateTimeStamp) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = String(this.selectedId);
      updateKeyValueMap["progress_at"] = {};
      if (this.selectedId != '1') {
        updateKeyValueMap["progress_at"][this.selectedId] = new Date(moment(this.now).local().format("YYYY/MM/DD HH:mm"));
      }
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-progress {
  .outer-area {
    padding: 1rem;
  }
  .candidate-list {
    margin: 0.2rem;
  }
  .progress-item {
    min-width: 8rem;
  }
  .current-time-item {
    font-size: 120%;
    padding: 1rem;
  }
  .save-button {
    margin: 0 1rem;
    width: 30%
  }
}
</style>

